<template>
  <div class="content">
    <b>【Smari宅配ボックスのご利用にあたって】</b>
    <div class="content-body">
      <ul class="privacy-policy">
        <li>
          「スマリ宅配ボックスサービス」（以下「本サービス」といいます）は三菱商事株式会社が提供するサービスです。
        </li>
        <li>
          本サービスは、別途定める対象事業者でないECサイトへの発送等ではご利用いただけません。
        </li>
        <li>本サービスの利用方法</li>
        <ol>
          <li>
            ECサイト上で発送登録を実施。その際、発送方法として本サービスを選択してください。
          </li>
          <li>
            発送登録が完了すると、ECサイトからスマリの利用に必要なQRコードが表示されます。QRコード画面の下部にある「スマリ宅配ボックスから発送」を選択してください。
          </li>
          <li>
            サインインして「発送受付」を選択してください（初回利用時にはユーザー登録が必要となります）。
          </li>
          <li>
            発送商品はお客様の責任においてECサイトの規定に従って梱包したうえで、スマリ宅配ボックスに投函してください。
          </li>
          <li>
            スマリ宅配ボックスの扉を閉めて、ご利用のデバイス（スマートフォンなど）でスマリ宅配ボックスに貼り付けてあるQRコードを読み込んでください。
          </li>
          <li>
            QRコードを読み取り後、ご利用のデバイス（スマートフォンなど）に表示された暗証番号でスマリ宅配ボックスを施錠してください。
          </li>
        </ol>
        <li>
          ユーザー登録時にはご住所などのお客様情報を正確に登録してください。また、ご引越しなど、登録情報に変更が生じる際には、必ず登録情報の変更手続きを行ってください。
        </li>
        <li>
          スマリ宅配ボックスの設置されている物件の所有者または居住者以外の方が、当該の宅配ボックスを利用することは禁止いたします。
        </li>
        <li>
          ECサイト上で本サービスを利用する発送登録をした商品以外の物は、絶対にスマリ宅配ボックスに入れないでください。万一、対象商品以外の物が投入された場合、その配送・保管等について当社は一切責任を負いません。また、商品の引受け後は、いかなる理由であっても、商品をお返しすることはできません。
        </li>
        <li>
          本サービスでは、発送商品の配達日時の指定、速達等の対応はできませんので、発送期限等には十分余裕をもってご利用ください。大雪・大雨等の天候不調や地震等の災害その他の事由により配送遅延・配送不能が発生した場合について、当社は一切の責任を負いません。
        </li>
        <li>
          ユーザー登録の不備、登録情報変更の不備、暗証番号入力の不備、スマリ宅配ボックスの故障、破損、不具合、その他の不備に起因して商品の引受けが出来なかった場合について、当社は一切の責任を負いません。
        </li>
        <li>
          商品の配送に関する手続・費用負担・責任は、各ECサイトの規定に従います。当社は各ECサイトから発送受付および配送に関する業務を受託して行うものであり、お客様に対してはいかなる責任も負いません。
        </li>
      </ul>
    </div>

    <b>【三菱商事グループ 個人情報保護基本方針】</b>
    <div class="content-body">
      <p>
        <a
          class="link-smari-color"
          href="https://www.mitsubishicorp.com/jp/ja/privacy/"
          target="_blank"
          rel="noopener noreferrer"
          >三菱商事グループ 個人情報保護基本方針</a
        >
      </p>
    </div>

    <b>【Smari個人情報の取扱い】</b>
    <div class="content-body">
      <p>
        当社は、本サービスにおける個人情報を本取扱いの定めに従い取り扱います。本取扱いに定めのない事項については、当社ウェブサイト（<a
          class="link-smari-color"
          href="https://www.mitsubishicorp.com/jp/ja/privacy/"
          target="_blank"
          rel="noopener noreferrer"
          >https://www.mitsubishicorp.com/jp/ja/privacy/</a
        >）
        「個人情報保護基本方針」（同ページに掲載される個人情報の利用目的、安全管理措置、開示等請求手続その他の定めを含みます。）の定めによります。
      </p>
      <ol>
        <li>
          個人情報の利用目的<br />
          当社は、他の方法でお知らせする場合を除き、スマリサービス（以下「本サービス」といいます）のご利用を通じてご提供いただいた個人情報を次の目的の達成に必要な範囲で取扱います。
          <ul>
            <li>お客様に対する本サービスの提供及び配送業務の遂行のため</li>
            <li>
              本サービスの研究・開発・改善等ならびにこれらに付随する調査・分析およびお客様に対するアンケート等の実施のため
            </li>
            <li>
              その他上記の目的を達成するために必要な、個人認証・本人確認の実施、その内容、結果の管理等のため
            </li>
            <li>第三者へ提供するため（「2.第三者提供の制限」に基づく）</li>
          </ul>
          当社では上記利用目的の達成に必要な範囲に限り、提供いただいた個人情報を業務委託先に提供する場合がございます。その場合には、委託された個人情報等の安全管理が図られるよう、業務委託先に対する必要かつ適切な監督を行います。
          また、法令等により提供を求められた場合には、当該公的機関に提供することがございます。
        </li>
        <li>
          第三者提供の制限
          <ol>
            <li>
              当社では「1.個人情報の利用目的」を達成に必要な範囲に限り、かつ本人から本プライバシーポリシーに同意を得たうえで、本サービスにおいて連携している以下第三者に提供することがございます。その際は、法令に従い必要な措置を講じます。
              <ul class="paren-list">
                <li>
                  (1) EC事業者：<br />問い合わせ対応を目的に関連する情報を提供
                </li>
                <li>
                  (2) 物流事業者：<br />問い合わせ対応を目的に関連する情報を提供
                </li>
                <li>
                  (3) コンサル事業者：<br />問い合わせ対応等のサービス向上を目的に分析・調査に必要な情報を提供
                </li>
              </ul>
            </li>
            <li>
              上記以外について、当社は、次に掲げる場合を除くほか、予めご本人の同意を得ないで、個人情報を第三者に提供しません。
              <ul class="paren-list">
                <li>(1) 法令に基づき開示・提供を求められた場合</li>
                <li>
                  (2)
                  人の生命、身体または財産の保護のために必要であり、本人の同意を得ることが困難な場合
                </li>
                <li>
                  (3)
                  公衆衛生の向上または高齢者虐待防止等の観点で関連機関との情報交換が必要となった場合であって本人の同意を得ることが困難な場合
                </li>
                <li>
                  (4)
                  国の機関若しくは地方公共団体またはその委託を受けた者が法令の定める事務を遂行することに対して協力する必要がある場合であって、本人の同意を得ることにより当該事務の遂行に支障を及ぼすおそれがある場合
                </li>
                <li>
                  (5)
                  契約書類において、第三者への提供があらかじめ明記されている場合
                </li>
              </ul>
            </li>
          </ol>
        </li>
        <li>
          安全管理措置<br />
          当社では、個人情報を適切に管理するため、組織的、人的、物理的、技術的な観点から、適切かつ効果的な安全管理措置を明確に定めて実施致します。個人情報および匿名加工情報等の保護に関する責任者を明確にし、社内規程を制定することにより管理体制を整備します。社内教育・啓発活動を実施して個人情報および匿名加工情報等の適正な取扱いについて周知徹底に努めるとともに、管理体制を継続的に見直します。また、当社が、第三者に個人情報の取扱いを委託する場合には、委託先の選定基準を定め、委託先の情報管理体制を確認し、委託後の業務遂行状況を監視する等委託先に対する必要かつ適切な監督を行います。
        </li>
        <li>
          個人情報の正確性の確保<br />
          当社では、お預かりしている個人情報は、利用目的の達成に必要な範囲内において、正確かつ最新の状態で管理するように努めます。また、利用する必要がなくなったときは当該個人情報を消去します。
        </li>
        <li>
          個人情報保護法に基づく開示等請求<br />
          当社では、個人情報保護法に基づき、ご本人からの申出により、保有個人情報の利用目的の通知、保有個人情報もしくは第三者提供記録の開示、保有個人情報の訂正等、利用停止等または第三者への提供の停止に関する請求(以下「開示等請求」といいます)があった場合には、以下のように対応いたします。
          <ol>
            <li>
              開示等請求に関する手続き<br />
              開示等請求を希望される場合は下記の問い合わせ窓口にご請求下さい。当社より所定の請求用紙をお送り致しますので、書類に必要事項をご記入のうえ、下記宛先までご送付下さい。この際、ご請求者の本人確認およびご本人の情報を特定するため、以下の書類も合わせてご送付願います。請求書類等の送付に係る費用についてはご請求者のご負担となりますので、あらかじめご了承下さい。
              <ul class="paren-list">
                <li>
                  (1) ご請求者がご本人の場合<br />運転免許証、健康保険証またはパスポート等の公的機関が発行した書類の写し
                </li>
                <li>
                  (2) ご請求者が代理人の場合
                  <ul>
                    <li>上記①の本人確認書類</li>
                    <li>
                      代理人自身の運転免許証、健康保険証等の公的機関が発行した書類の写し
                    </li>
                    <li>
                      法定代理人の場合は、法定代理権があることを確認できる書類（戸籍謄本、後見開始審判書等）
                    </li>
                    <li>委任による代理人は委任状</li>
                  </ul>
                </li>
              </ul>
            </li>
            <li>
              回答方法<br />
              お受けした開示等請求については、請求内容の確認・調査等を行い、手数料を要する請求については、入金を確認させていただいたうえで、ご本人に対して遅滞なくご回答致します。また代理人によるご請求の場合には、ご本人の権利・利益を侵害しないことを確認した上で、当該代理人に対し遅滞なくご回答申し上げます。保有個人情報または第三者提供記録の開示請求に関する回答方法は、書面または電磁的記録の提供のうち、ご本人が請求した方法によることを原則とします。
            </li>
            <li>
              手数料<br />
              開示等請求のうち、保有個人情報の利用目的の通知または保有個人情報もしくは第三者提供記録の開示に係る請求については、手数料として1,000円（税込）をご負担いただきますので、当社指定の口座に手数料をお振込下さい。振り込み手数料についてはご請求者のご負担となりますのでご了承下さい。手数料が不足している場合、その旨ご連絡いたしますが、所定の期間内にお支払いのない場合は、ご請求がなかったものとして処理いたします。あらかじめご了承ください。
            </li>
            <li>
              開示等請求の例外<br />
              開示等請求に応じることにより、ご本人または第三者の生命、身体、財産その他の権利・利益を害するおそれがある場合、当社の業務の適正な実施に著しい支障を及ぼすおそれがある場合および他の法令に違反することとなる場合等請求に応じることができない場合がございますが、その場合にはその理由を付してご回答致します。
            </li>
          </ol>
        </li>
        <li>
          プライバシーポリシーの変更<br />
          当社は、プライバシーポリシーの内容を必要に応じて変更することがあります。プライバシーポリシーの変更を行う場合には、あらかじめ本サイトにおいて公表いたします。
        </li>
        <li>
          お問い合わせ窓口<br />
          〒100-8086 東京都千代田区丸の内二丁目3番1号<br />
          三菱商事株式会社 金融・物流本部 物流開発部
        </li>
      </ol>
    </div>
    <br />
    <div class="acknowledge-footer">
      以 上<br />
      〒100-8086<br />
      東京都千代田区丸の内二丁目3番1号<br />
      三菱商事株式会社<br />
      代表取締役社長 中西 勝也<br />
    </div>
  </div>
</template>

<script>
export default {
  name: "PrivacyPolicy",
}
</script>

<style scoped>
.content {
  padding: 0;
}
.content ul {
  margin-top: 0.3em;
}
.content ol {
  margin-top: 0.5em;
}
.content-body {
  padding: 0.3em 0 0 0;
  margin-bottom: 1.5em;
}
.content-body p {
  padding-left: 0.6em;
}
ul ol {
  margin-top: 2px;
}
.acknowledge-footer {
  text-align: right;
}
.link-smari-color {
  color: #2c3e50;
  text-decoration: underline;
}
.content .paren-list {
  list-style: none;
  margin: 0.3em 0 0 0;
  padding-left: 0;
}
.content .paren-list > li {
  padding-left: 1.5em;
  text-indent: -1.4em;
}
.content .paren-list li ul {
  text-indent: 0;
}
</style>
